import { ChevronLeft, ChevronRight } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '../cn'
import { Button } from './Button'

export interface PaginationProps {
  hasPrevious: boolean
  hasNext: boolean
  onPrevious: () => void
  onNext: () => void
  /** Status text ("Showing 1–25 of 132"). */
  summary?: ReactNode
  /** Disable both buttons (a page is loading). */
  busy?: boolean
  className?: string
}

/** Previous / next pager. Works for page numbers (client) and opaque cursors (server). */
export function Pagination({
  hasPrevious,
  hasNext,
  onPrevious,
  onNext,
  summary,
  busy,
  className,
}: PaginationProps) {
  return (
    <nav
      aria-label="Pagination"
      className={cn(
        'flex flex-wrap items-center justify-between gap-3 text-[13px] text-sage',
        className,
      )}
    >
      <p aria-live="polite" className="tabular-nums">
        {summary}
      </p>
      <div className="flex gap-2">
        <Button
          variant="secondary"
          size="sm"
          icon={<ChevronLeft />}
          disabled={!hasPrevious || busy}
          onClick={onPrevious}
        >
          Previous
        </Button>
        <Button
          variant="secondary"
          size="sm"
          trailingIcon={<ChevronRight />}
          disabled={!hasNext || busy}
          onClick={onNext}
        >
          Next
        </Button>
      </div>
    </nav>
  )
}
